import * as React from 'react';
import { Expander } from 'sos-common/js/components/Expander/Expander';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { LEG_FILE_MIMETYPES, SPEC_FILE_MIMETYPES } from './FilKomplettering.mimetypes';
import { FilKompletteringProps, FilKompletteringState, PostFilesServerResponseObject } from './FilKomplettering.types';
import { Dialog } from 'sos-common/js/components/Dialog/Dialog';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { sendCompletion } from 'sos-eservice-common/js/services/completion.service';
import { postFile, deleteFile } from 'sos-eservice-common/js/services/files.service';
import { stringWithLineBreak } from 'sos-common/js/utils/helpers';
import { makeTranslator } from 'sos-common/js/utils/translations';
import { ResponseError } from 'sos-common/js/utils/ResponseError';

let Translate: (key: string, defaultValue?: string) => string;
export class FilKomplettering extends React.Component<FilKompletteringProps, FilKompletteringState> {
  static defaultProps = {
    uploadLinkText: 'Ladda upp fil',
    noFilesUploadedText: 'Du har inte laddat upp någon fil ännu',
    sendButtontext: 'Skicka komplettering',
    removeButtonText: 'Ta bort',
  };

  constructor(props: FilKompletteringProps) {
    super(props);
    Translate = makeTranslator(props.translations);
    this.state = {
      kompletteringId: this.props.kompletteringId,
      unlockSendButton: this.props.Files.length > 0,
      fileUploadState: this.props.Files,
      serverResponseObject: null,
      IsInskickad: false,
      clientError: null,
      showDialog: false,
      sendSuccess: null,
      sendCompletionErrorMessage: '',
    };
  }

  getApiEndpoint = () =>
    this.props.apiEndpointBaseUrl
      ? this.props.apiEndpointBaseUrl + this.props.fileTag
      : '/_api/ansokan/' + this.props.fileTag;

  setErrorMessage = (errorMessage: string) => {
    this.setState({
      clientError: {
        error: null,
        errorMessage: errorMessage || Translate('/errorMessages/unhandledException'),
      },
    });
  };

  onAddFile = (field: FormFieldFile) => {
    const { ansokanId, currentLanguage } = this.props;

    this.setState({
      fileUploadState: field.value,
    });

    const currLang = currentLanguage ? `/${currentLanguage}` : '';
    const apiEndpoint = `${this.getApiEndpoint()}/addfile/${ansokanId}/${this.state.kompletteringId}${currLang}`;

    postFile<PostFilesServerResponseObject>(field, apiEndpoint, new FormData()).then((response) => {
      if (response instanceof ResponseError) {
        this.setErrorMessage(response.body.errorMessage);
        const files = field.value.filter((file) => !!file.FileId);
        this.setState({ fileUploadState: files });
      } else {
        this.setState({
          kompletteringId: response.serverResponse.kompletteringId, //NOTE: for frivillig komplettering, the first file also creates the Komplettering.
          unlockSendButton: response.fileUploadValue.length > 0 ? true : false,
          fileUploadState: response.fileUploadValue,
          serverResponseObject: response.serverResponse,
          clientError: null,
        });
      }
    });
  };

  onDeleteFile = (file: FileExtendedDetails, fieldName: string, field: FormFieldFile) => {
    const { ansokanId } = this.props;
    const apiEndpoint = `${this.getApiEndpoint()}/deletefile/${file.FileId}/${ansokanId}/${this.state.kompletteringId}`;

    deleteFile(apiEndpoint, new FormData()).then((response) => {
      if (response instanceof ResponseError) {
        this.setErrorMessage(response.body.errorMessage);
      } else {
        const fileId = (response as any).FileId;
        let newFileUploadState = this.state.fileUploadState.slice();
        let index = newFileUploadState.findIndex((val) => {
          return val.FileId === fileId;
        });
        newFileUploadState.splice(index, 1);

        this.setState({
          fileUploadState: newFileUploadState,
          clientError: null,
          unlockSendButton: newFileUploadState.length > 0,
        });
      }
    });
  };

  onSendClick = () => {
    const { ansokanId } = this.props;
    const apiEndpoint = this.getApiEndpoint() + `/submit/${ansokanId}/${this.state.kompletteringId}`;
    const formData = new FormData();

    sendCompletion(apiEndpoint, formData).then((response) => {
      if (response instanceof ResponseError) {
        this.setState({
          showDialog: true,
          sendSuccess: false,
          sendCompletionErrorMessage: response.body.errorMessage || Translate('/errorMessages/unhandledException'),
        });
      } else {
        this.setState({
          showDialog: true,
          sendSuccess: true,
        });
      }
    });
  };

  closeConfirm = () => {
    this.setState({
      showDialog: false,
    });
    window.location.reload();
  };

  reloadPage = () => {
    window.location.reload();
  };

  renderSuccessDialog = () => {
    return (
      <Dialog isOpen={this.state.showDialog} onRequestClose={this.closeConfirm}>
        <button onClick={this.closeConfirm} className="close">
          <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
        </button>
        <div className="header">
          <h2>{Translate('/overviewPage/uploadSuccess')}</h2>
        </div>
        <p>{Translate('/overviewPage/supplementationSentText')}</p>
        <div className="footer">
          <input
            type="submit"
            className="button"
            onClick={this.reloadPage}
            value={Translate('/overviewPage/closeDialogButtonText')}
          />
        </div>
      </Dialog>
    );
  };

  renderFailDialog = () => {
    return (
      <Dialog isOpen={this.state.showDialog} onRequestClose={this.closeConfirm}>
        <button onClick={this.closeConfirm} className="close">
          <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
        </button>
        <div className="header">
          <h2>{Translate('/errorMessages/fileErrorMessages/unexpectedError')}</h2>
        </div>
        <p>{Translate('/errorMessages/fileErrorMessages/failedDialogText')}</p>
        <div className="error-code">{this.state.sendCompletionErrorMessage}</div>
      </Dialog>
    );
  };

  // getfileErrorMessage = (totalFileCount: number, nbrOfFilesUploaded: number) => {
  //   const restrictions = this.props.restrictions;

  //   let fileErrorMessage = totalFileCount >= restrictions.MaxTotalFiles.Number ?  restrictions.MaxTotalFiles.ErrorMessage : null;
  //   if (!fileErrorMessage && nbrOfFilesUploaded >= restrictions.MaxFilesPerUpload.Number)
  //     fileErrorMessage =restrictions.MaxFilesPerUpload.ErrorMessage;
  //   return fileErrorMessage;
  // }

  public render() {
    const {
      expandIcon,
      expandCssClass,
      fileHeading,
      innerHeading,
      innerParagraph,
      documentList,
      dhsId,
      uploadLinkText,
      noFilesUploadedText,
      sendButtontext,
      removeButtonText,
    } = this.props;

    let expandHeading = this.props.expandHeading;
    if (dhsId) expandHeading += ` - ${dhsId}`;

    return (
      <div>
        <Expander isExpanded={false} heading={expandHeading} icon={expandIcon} cssClass={expandCssClass}>
          {innerHeading && <h3>{innerHeading}</h3>}
          <p dangerouslySetInnerHTML={{ __html: stringWithLineBreak(innerParagraph) }}></p>
          {documentList && (
            <div>
              <br />
              {documentList.map((item) => {
                return (
                  <div key={item.fileName} className="filelist-item filelist-item--nodate">
                    <div className="filelist-item__name">
                      <a className={`file-extension-icon ${item.fileExtension}`} href={item.url}>
                        {item.fileName}
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <br />
          <br />
          <Fileupload
            id={dhsId}
            disabled={false}
            max={10}
            heading={fileHeading}
            upload={uploadLinkText}
            value={this.state.fileUploadState}
            nofilesText={noFilesUploadedText}
            mimetype={this.props.educatedInSweden ? SPEC_FILE_MIMETYPES : LEG_FILE_MIMETYPES}
            onAdd={this.onAddFile}
            onRemove={this.onDeleteFile}
            maxFileSize={10485760} //10 mb
            clientError={this.state.clientError}
            removeText={removeButtonText}
            removeFilePopupBody={Translate('/errorMessages/fileErrorMessages/removeFilePopupBody')}
            removeFileText={Translate('/errorMessages/fileErrorMessages/removeFileText')}
            closeText={Translate('/errorMessages/fileErrorMessages/closeText')}
            abortText={Translate('/errorMessages/fileErrorMessages/abortText')}
            maxFileSizeErrorMessage={Translate('/errorMessages/fileErrorMessages/maxFileSizeErrorMessage')}
          />
          <hr className="expand-block__hr" />
          <div className="centered-button">
            <button disabled={this.state.unlockSendButton ? false : true} onClick={this.onSendClick} className="button">
              {sendButtontext}
            </button>
          </div>
        </Expander>

        {this.state.sendSuccess && this.renderSuccessDialog()}

        {!this.state.sendSuccess && this.renderFailDialog()}
      </div>
    );
  }
}
